import { render, staticRenderFns } from "./TrucksListing.vue?vue&type=template&id=028b0fec&scoped=true"
import script from "./TrucksListing.vue?vue&type=script&lang=js"
export * from "./TrucksListing.vue?vue&type=script&lang=js"
import style0 from "./TrucksListing.vue?vue&type=style&index=0&id=028b0fec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028b0fec",
  null
  
)

export default component.exports